<div class="dynamic-datepicker">
    <mat-form-field appearance="outline" class="example-form-field" *ngIf="isEditingMode(inputLabel)">
        <mat-label>{{inputLabel}}</mat-label>
        <input matInput [matDatepicker]="datepicker"  [(ngModel)]="inputValue" (dateChange)="onDateChange($event)">
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
        <mat-datepicker #datepicker>
        </mat-datepicker>
      </mat-form-field>
    
    <mat-label *ngIf="inputValue != null && !isEditingMode(inputLabel)" style="font-size: 10px;">{{inputLabel}}</mat-label>
    <mat-chip-list *ngIf="!isEditingMode(inputLabel)" class="chip-edit" >
      <mat-chip *ngIf="inputValue != null" class="chip-edit" color="primary" selected (click)="switchEditingMode(inputLabel)"> 
        {{shortDate}}
      </mat-chip>
      <mat-chip (click)="switchEditingMode(inputLabel)" *ngIf="!inputValue"> 
        {{inputLabel}}: 
      </mat-chip>
    </mat-chip-list>
    
    <i class="fas fa-solid fa-angle-up icon" *ngIf="isEditingMode(inputLabel)" (click)="switchEditingMode(inputLabel)"></i>
  </div>